
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F2382F","fill-rule":"evenodd","d":"M4.613 3.21l.094.083L8 6.585l3.293-3.292a1 1 0 011.497 1.32l-.083.094L9.415 8l3.292 3.293a1 1 0 01-1.32 1.497l-.094-.083L8 9.415l-3.293 3.292a1 1 0 01-1.497-1.32l.083-.094L6.585 8 3.293 4.707a1 1 0 011.32-1.497z"}})])
          )
        }
      }
    